<template>
  <div>
    <PageAllow
      controller="StockDetails"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("stockDetail.objectName") }}
              <!-- 冻结状态 -->
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="stock_detail.prohibit_flg | prohibitFlgsColor"
                :text-color="stock_detail.prohibit_flg | prohibitFlgsTextColor"
                >{{ stock_detail.prohibit_flg | prohibitFlgsText }}
              </v-chip>
              <!-- 过期状态 -->
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="stock_detail.expired_flg | expiredFlgsColor"
                :text-color="stock_detail.expired_flg | expiredFlgsTextColor"
                >{{ stock_detail.expired_flg | expiredFlgsText }}
              </v-chip>
              <v-spacer />
              <!-- 操作 -->
              <StockDetailsActions
                v-if="isView"
                :stock_detail="stock_detail"
                detail-model
                showProhibit
                showUnProhibit
                showLoss
                showPrint
                showExport
                @done="getStockDetailsFromAPI"
              />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <ValidationObserver ref="observer">
            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <!-- 批次号 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.stock_batch_code")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_detail.stock_batch_code }}
                  </v-card>
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.material")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      stock_detail && stock_detail.material
                        ? stock_detail.material.material_name
                        : ""
                    }}
                  </v-card>
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.material_category")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{
                        stock_detail && stock_detail.material
                          ? stock_detail.material.material_category.name
                          : ""
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 生产日期 小-->
                <v-col
                  cols="12"
                  md="4"
                  v-if="!isNew"
                  class="d-inline d-md-none"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.production_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="editStockDetailDate"
                      class="my-n2"
                      v-model="stock_detail.production_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_detail.production_date | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 过期日期 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="!isNew"
                  class="d-inline d-md-none"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.expired_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="editStockDetailDate"
                      class="my-n2"
                      v-model="stock_detail.expired_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_detail.expired_date | formatTime }}
                    </span>
                    <!-- 实际发生时间 -->
                  </v-card>
                </v-col>
                <!-- 入库量 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.stock_in_num")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_detail.stock_first }}{{ stock_detail.unit }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 生产日期 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="!isNew"
                  class="d-none d-md-inline"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.production_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="editStockDetailDate"
                      class="my-n2"
                      v-model="stock_detail.production_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                      disabled-after-now
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_detail.production_date | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 过期日期 -->
                <v-col
                  cols="12"
                  md="4"
                  v-if="!isNew"
                  class="d-none d-md-inline"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.expired_date")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      v-if="editStockDetailDate"
                      class="my-n2"
                      v-model="stock_detail.expired_date"
                      type="datetime"
                      single-line
                      dense
                      hide-details
                      disabled-before-today
                    >
                    </SearcherDatetime>
                    <span v-else>
                      {{ stock_detail.expired_date | formatTime }}
                    </span>
                    <!-- 实际发生时间 -->
                  </v-card>
                </v-col>
                <!-- 剩余 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.stock_current")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_detail.stock_current }}{{ stock_detail.unit }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 单价 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.price")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ $t("Global.money")
                    }}{{ stock_detail.price | formatMoney }}
                  </v-card>
                </v-col>
                <!-- 小计 -->
                <v-col cols="12" md="4" v-if="!isNew">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("stockDetail.Fields.count_num")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ $t("Global.money") }}{{(stock_detail.stock_current * stock_detail.price)| formatMoney }}
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </ValidationObserver>
        </v-expansion-panel>
        <v-expansion-panel v-if="!isNew" readonly>
          <!-- tab -->
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("StockDetails.actions.stock_order_in") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content readonly>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="stockOrderInHeaders"
                    :items="[stock_in_orders]"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created>
                      <span class="text-no-wrap">
                        <!-- 取批次的创建时间即入库完成时间 -->
                        {{ stock_detail.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.type="{ item }">
                      {{ item.type | stockOrderINTypesText }}
                    </template>
                    <template v-slot:item.qualify_report_img_url>
                      <!-- 质检报告 -->
                      <v-btn
                        v-if="(stock_detail && stock_detail.stock_in_order_detail && (stock_detail.stock_in_order_detail.qualify_report_img_url && stock_detail.stock_in_order_detail.qualify_report_img_url.length))"
                        color="orange"
                        style="color: white"
                        class="my-1"
                        small
                        @click.stop="
                          qualifyReportDialog = true;
                        "
                      >
                        {{ $t("stockInOrders.DetailFields.qualify_report_img_url") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- // -->
      <DialogImages
        v-model="qualifyReportDialog"
        :img_url="(stock_detail && stock_detail.stock_in_order_detail && stock_detail.stock_in_order_detail.qualify_report_img_url) ? stock_detail.stock_in_order_detail.qualify_report_img_url : []"
      />
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import StockDetails from "@/api/stock_details";
import StockDetailsActions from "./plugins/Actions";
import DialogImages from "@/components/plugins/DialogImages";
import { ValidationObserver } from "vee-validate";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationObserver,
    StockDetailsActions,
    SearcherDatetime,
    DialogImages,
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "new" || this.mode == "edit";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stockDetails"),
          disabled: false,
          href: "/stock-details",
        },
        {
          text: i18n.t("Nav.stockDetail"),
          disabled: true,
        },
        {
          text:
            this.stock_detail && this.stock_detail.stock_batch_code
              ? this.stock_detail.stock_batch_code
              : "",
          disabled: false,
          accent: true,
        },
      ];
      return items;
    },

    stockOrderInHeaders() {
     let headers = [
       {
         text: i18n.t("StockDetails.InFeilds.created_time"),
         align: "start",
         sortable: false,
         value: "created",
       },
       {
         text: i18n.t("StockDetails.InFeilds.in_type_str"),
         align: "start",
         sortable: false,
         value: "type",
       },
       {
         text: i18n.t("StockDetails.InFeilds.in_stock"),
         align: "start",
         sortable: false,
         value: "stock.name",
       },
       {
         text: i18n.t("StockDetails.InFeilds.code"),
         align: "start",
         sortable: false,
         value: "stock_order_code",
       },
       {
         text: i18n.t("StockDetails.InFeilds.stock"),
         align: "start",
         sortable: false,
         value: "stock.name",
       },
       {
         text: i18n.t("StockDetails.InFeilds.creater"),
         align: "start",
         sortable: false,
         value: "operater_name",
       },
     ]
      if (this.accountSettings && this.accountSettings.qualify_report_enable) {
        headers.push({
          text: i18n.t("Examine.DetailFields.qualify_report_img"),
          align: "start",
          value: "qualify_report_img_url",
        });
      }

      return headers;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountSettings"]),
  },

  mounted() {
    this.mode = this.$route.params.mode;
    if (this.mode)
      this.$router.replace("/stock-details/" + this.$route.params.id);
  },

  data: () => ({
    editStockDetailDate: false,
    panels: [0, 1],
    tab: null,
    mode: "",
    stock_detail: {},
    stock_in_orders: {},
    qualifyReportDialog: false,
  }),

  methods: {
    getStockDetailsFromAPI() {
      StockDetails.fetchOne(this.$route.params.id, this.$options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_detail = response.data.stock_detail;
            // 入库单
            this.stock_in_orders = response.data.stock_detail.stock_in_order
          }
        }.bind(this)
      );
    },
    save() {
      StockDetails.save({
        id: this.$route.params.id,
        production_date: this.stock_detail.production_date,
        expired_date: this.stock_detail.expired_date,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/stock-details");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.isNew) {
          this.stock_detail.actual_date = this.$datetimeUtils.formatTime(
            new Date()
          );
        } else if (this.$route.params.id) {
          this.getStockDetailsFromAPI();
        }
      },
    },
  },
};
</script>